// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-wrapper-45 {
    position: relative;
  }

  .checkbox-wrapper-45 input[type="checkbox"] {
    display: none;
    visibility: hidden;
  }
  .checkbox-wrapper-45 .cbx {
    perspective: 20;
    display: inline-block;
    border: 2px solid var(--cinza-em-aberto);
    background: var(--fundo-input);
    border-radius: 4px;
    transform: translate3d(0, 0, 0);
    cursor: pointer;
    transition: all 0.3s ease;
  }
  .checkbox-wrapper-45 .cbx:hover {
    border-color: var(--azul-dixi);
  }
  .checkbox-wrapper-45 .flip {
    display: block;
    transition: all 0.4s ease;
    transform-style: preserve-3d;
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
  }
  .checkbox-wrapper-45 input[type="checkbox"]:checked + .cbx {
    border-color: var(--azul-dixi);
  }
  .checkbox-wrapper-45 input[type="checkbox"]:checked + .cbx .flip {
    transform: rotateY(180deg);
  }
  .checkbox-wrapper-45 .front,
  .checkbox-wrapper-45 .back {
    backface-visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 2px;
  }
  .checkbox-wrapper-45 .front {
    background: var(--fundo-input);
    z-index: 1;
  }
  .checkbox-wrapper-45 .back {
    transform: rotateY(180deg);
    background: var(--azul-dixi);
    text-align: center;
    color: var(--fundo-input);
    line-height: 1.5rem;
    box-shadow: 0 0 0 1px var(--azul-dixi);
  }
  .checkbox-wrapper-45 .back svg {
    margin-top: 5px;
    fill: none;
  }
  .checkbox-wrapper-45 .back svg path {
    stroke: var(--fundo-input);
    stroke-width: 2.5;
    stroke-linecap: round;
    stroke-linejoin: round;
  }`, "",{"version":3,"sources":["webpack://./src/components/Checkbox/Checkbox.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;EACA;IAEE,eAAe;IACf,qBAAqB;IACrB,wCAAwC;IACxC,8BAA8B;IAC9B,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,cAAc;EAChB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;IAC3B,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,8BAA8B;IAC9B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,sCAAsC;EACxC;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;EACxB","sourcesContent":[".checkbox-wrapper-45 {\n    position: relative;\n  }\n\n  .checkbox-wrapper-45 input[type=\"checkbox\"] {\n    display: none;\n    visibility: hidden;\n  }\n  .checkbox-wrapper-45 .cbx {\n    -webkit-perspective: 20;\n    perspective: 20;\n    display: inline-block;\n    border: 2px solid var(--cinza-em-aberto);\n    background: var(--fundo-input);\n    border-radius: 4px;\n    transform: translate3d(0, 0, 0);\n    cursor: pointer;\n    transition: all 0.3s ease;\n  }\n  .checkbox-wrapper-45 .cbx:hover {\n    border-color: var(--azul-dixi);\n  }\n  .checkbox-wrapper-45 .flip {\n    display: block;\n    transition: all 0.4s ease;\n    transform-style: preserve-3d;\n    position: relative;\n    width: 1.5rem;\n    height: 1.5rem;\n  }\n  .checkbox-wrapper-45 input[type=\"checkbox\"]:checked + .cbx {\n    border-color: var(--azul-dixi);\n  }\n  .checkbox-wrapper-45 input[type=\"checkbox\"]:checked + .cbx .flip {\n    transform: rotateY(180deg);\n  }\n  .checkbox-wrapper-45 .front,\n  .checkbox-wrapper-45 .back {\n    backface-visibility: hidden;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 1.5rem;\n    height: 1.5rem;\n    border-radius: 2px;\n  }\n  .checkbox-wrapper-45 .front {\n    background: var(--fundo-input);\n    z-index: 1;\n  }\n  .checkbox-wrapper-45 .back {\n    transform: rotateY(180deg);\n    background: var(--azul-dixi);\n    text-align: center;\n    color: var(--fundo-input);\n    line-height: 1.5rem;\n    box-shadow: 0 0 0 1px var(--azul-dixi);\n  }\n  .checkbox-wrapper-45 .back svg {\n    margin-top: 5px;\n    fill: none;\n  }\n  .checkbox-wrapper-45 .back svg path {\n    stroke: var(--fundo-input);\n    stroke-width: 2.5;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
